import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MoradoresComRendaFormPage } from './moradores-com-renda-form.page';

const routes: Routes = [{ path: '', component: MoradoresComRendaFormPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MoradoresComRendaFormPageRoutingModule { }
